import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import LessonsColumn from './LessonsColumn'
import language from '../../variables/language';

export default function ScheduleContainer({ url, refresh, onOpenLesson }) {
   const navigate = useNavigate();
   const [days, setDays] = useState([]);
   const [status, setStatus] = useState('wait');
   const lang = language[language.lang];

   useEffect(() => {
      setStatus('wait');
      axios.get(url, { withCredentials: true })
         .then(response => {
            setDays(Array.isArray(response.data) ? response.data : []);
            setStatus('done');
         })
         .catch(err => {
            if (err.response && err.response.status === 401) navigate('/login');
            setStatus('error');
         });
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [url])

   const todayStr = (() => {
      const now = new Date();
      return now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0') + '-' + String(now.getDate()).padStart(2, '0');
   })();

   if (status === 'wait' && days.length === 0) {
      return <div className='schedule-grid-empty'>{lang['Loading ...']}</div>;
   }
   if (days.length === 0) {
      return <div className='schedule-grid-empty'>{lang['Empty list']}</div>;
   }

   return (
      <div className={'schedule-grid' + (days.length > 7 ? ' many-days' : '')}>
         {days.map((day, index) => (
            <LessonsColumn key={day.date} day={day} today={todayStr} refresh={refresh}
               url='/api/lessons' onOpenLesson={onOpenLesson} enterDelay={Math.min(index * 45, 260)} />
         ))}
      </div>
   )
}
